<template>
    <div class="grid sm:grid-cols-2 gap-x-1 sm:gap-x-4" data-cy="container_profile_form">
        <InputText
                v-model:inputValue="formData.firstName"
                :maxLength="50"
                :isTextOnly="true"
                :errorInfo="errorInfo[0]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.profile.firstname"
                data-cy="input_profile_first_name"
        ></InputText>
        <InputText
                v-model:inputValue="formData.lastName"
                :maxLength="50"
                :isTextOnly="true"
                :errorInfo="errorInfo[1]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.profile.lastname"
                data-cy="input_profile_last_name"
        ></InputText>
        <InputContactNumber
                v-model:inputValue="formData.contactNumber"
                :minLength="12"
                :maxLength="12"
                delimeter="-"
                :errorInfo="errorInfo[2]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.profile.contactNumber"
                data-cy="input_profile_contact_number"
        ></InputContactNumber>
        <InputEmail
                v-model:inputValue="formData.email"
                :maxLength="50"
                :errorInfo="errorInfo[3]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.profile.email"
                data-cy="input_profile_email"
        ></InputEmail>
        <!-- 1957496068748 -->
        <InputNationalId
                v-model:inputValue="formData.nationalIdCard"
                :errorInfo="errorInfo[4]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.profile.idCard"
                data-cy="input_profile_national_id"
        ></InputNationalId>
        <InputDropdown
                v-model:inputValue="formData.gender"
                :itemList="dropdownGender"
                :errorInfo="errorInfo[5]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.profile.gender"
                data-cy="input_profile_gender"
        ></InputDropdown>
        <DatePickerDropdown
                v-model:inputValue="formData.birthDate"
                :errorInfo="errorInfo[6]"
                :isShowError="true"
                :isSubmitted="isSubmitted"
                :inputLbl="lbl.profile.birthdate"
                data-cy="input_profile_birthdate"
        ></DatePickerDropdown>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import { FormHelper, DropdownListValue } from "@/helper/FormHelper.js";
//component
import InputText from "@/components/Input/label/InputText.vue";
import InputContactNumber from "@/components/Input/label/InputContactNumber.vue";
import InputEmail from "@/components/Input/label/InputEmail.vue";
import InputNationalId from "@/components/Input/label/InputNationalId.vue";
import InputDropdown from "@/components/Input/label/InputDropdown.vue";
import DatePickerDropdown from "@/components/Input/label/DatePickerDropdown.vue";
//mixin
// import AuthPageMixin from "@/mixin/AuthPageMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "FormProfile",
    mixins: [LocaleMixin],
    components: {
        InputText,
        InputContactNumber,
        InputEmail,
        InputNationalId,
        InputDropdown,
        DatePickerDropdown,
    },
    props: {
        setFormData: Object,
        modalController: Object,
    },
    data: function() {
        return {
            formData: null,

            isSubmitted: false,
            errorInfo: FormHelper.genErrorInfo(7),
            dropdownGender: null,
        };
    },
    created: function() {
        Util.log("form data", this.setFormData);
        this.setDropdown();
        this.formData = this.setFormData;
    },
    methods: {
        setDropdown: function() {
            let list = new DropdownListValue();
            list.add(this.lbl.profile.male, 'male');
            list.add(this.lbl.profile.female, 'female');
            list.add(this.lbl.profile.notspecified, 'notspecified');
            this.dropdownGender = list.getList();
        },
        submit: function() {
            this.isSubmitted = true;
            Util.log("form", this.formData);
            if (this.validate()) {
                return this.formData;
            }
            return null;
        },
        validate: function() {
            for (let i of this.errorInfo) {
                if (!i.isValid) {
                    this.modalController.alertModal
                            .clearModal()
                            .setMsg(i.msg)
                            .show();
                    return false;
                }
            }
            return true;
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
